module.exports = __webpack_public_path__ + "static/media/left_ailgn_01.2e1dd299.jpeg";